import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="bg-black">{children}</div>
      <Footer />
    </>
  );
};

export default Layout;
